// extracted by mini-css-extract-plugin
export default {"base":"Admin_base__7vcjP","card":"Admin_card__5zol9","title":"Admin_title__3ZnHB","records":"Admin_records__rlPJO","count":"Admin_count__OMnKl"};